import coreAPI from 'apis/core';

export async function sendEvent(pharmacyId, screen, action, options = {}) {
  const response = await coreAPI.event.sendEvent(pharmacyId, screen, action, options);
  return response.data;
}

export default {};
